import ReimbursementsUpsellSvg from 'ext-ui/svg/illustration/ReimbursementsUpsellSvg'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import LayoutPage from 'src/component-layout/LayoutPage/LayoutPage'
import NotFoundBackgroundPageContent from 'src/components/NotFoundBackgroundPageContent/NotFoundBackgroundPageContent'
import OrgSettingsOutOfPocketExpensesBox from 'src/components/OrgSettingsOutOfPocketExpensesBox/OrgSettingsOutOfPocketExpensesBox'
import { useCurrentUser } from 'src/context/UserProvider/useUser'
import SaasUpgradeOrContent from 'src/feature/SaasUpgradeOrContent/SaasUpgradeOrContent'
import { useBackgroundDispatch } from 'src/hooks'
import { useTranslate } from 'src/localization/Trns'
import { UserFeature } from 'src/models/user.models'
import { getOrganization } from 'src/redux/actions/data/organizations.actions'
import {
  selectOrganizationIdFromRoute,
  selectUserExplicitOrganizationListModelFromState,
} from 'src/redux/selectors/data/organizations.selectors'
import { selectAppName } from 'src/redux/selectors/session.selectors'
import { css } from 'styled-components'

const Reimbursements: React.FC = () => {
  const user = useCurrentUser()
  const organization = useSelector(
    selectUserExplicitOrganizationListModelFromState,
  )
  const organizationId = useSelector(selectOrganizationIdFromRoute)
  const appName = useSelector(selectAppName)

  const dispatch = useBackgroundDispatch()
  const translate = useTranslate()

  useEffect(() => {
    dispatch(getOrganization(organizationId))
  }, [])

  if (!user || !user.hasOrgBookkeeperPermissions || !organization) {
    return <NotFoundBackgroundPageContent />
  }

  return (
    <>
      <Helmet>
        <title>{`Reimbursements | ${appName}`}</title>
        <meta
          name="description"
          content={`Reimbursements page of ${appName}`}
        />
      </Helmet>
      <LayoutPage padding={'none'}>
        <SaasUpgradeOrContent
          illustration={<ReimbursementsUpsellSvg />}
          title={translate('Reimbursements')}
          description={translate(
            'No more scattered spreadsheets. Bring every reimbursement into the same workflow as your card spend. Review, approve, and track - all in one place',
          )}
          ctaDetailSrc={
            'Upgrade to ${tier} today to turn manual reimbursements into manageable workflows.'
          }
          feature={UserFeature.MANAGER_ASSIGNMENT}
        >
          <LayoutPage title={<span>{translate('Reimbursements')}</span>}>
            <div
              css={css`
                max-width: 570px;
              `}
            >
              <OrgSettingsOutOfPocketExpensesBox
                organization={organization}
                user={user}
              />
            </div>
          </LayoutPage>
        </SaasUpgradeOrContent>
      </LayoutPage>
    </>
  )
}

export default Reimbursements
